import React, {useEffect, useState} from "react";
import ComparisonListItem from "./comparison-list-item";

export default function ComparisonList({data = {}, columns, zeroValuesShown, expandedAllCount, collapsedAllCount, handleToggleAccountDetails}) {
    const tableSections = {incomes: {}, expenses: {}}
    const accountTypeList = {}

    Object.values(data).forEach((it) => {
        const item = Object.values(it);

        if (item?.[0]) {
            if (item[0].MainAccountTypeID === 2) { // income

                if (!tableSections['incomes'][item[0].AccountType]) {
                    tableSections['incomes'][item[0].AccountType] = item[0].AccountTypeID;
                }
            }

            if (item[0].MainAccountTypeID === 1) { // income
                if (!tableSections['expenses'][item[0].AccountType]) {
                    tableSections['expenses'][item[0].AccountType] = item[0].AccountTypeID;
                }
            }

            if (!accountTypeList[item[0].AccountType]) {
                accountTypeList[item[0].AccountType] = item[0].AccountType;
            }
        }

    });

    const [collapsedSection, setCollapsedSection] = useState({});

    function handleToggleCollapseSectionClick(name) {
        const collapsedSectionUpdate = Object.assign({}, collapsedSection);

        if (collapsedSectionUpdate[name]) {
            delete collapsedSectionUpdate[name];
        } else {
            collapsedSectionUpdate[name] = name;
        }

        setCollapsedSection(collapsedSectionUpdate);
    }

    useEffect(() => {
        if (expandedAllCount) {
            setCollapsedSection({});
        }
    }, [expandedAllCount]);

    useEffect(() => {
        if (collapsedAllCount) {
            setCollapsedSection(accountTypeList);
        }
    }, [collapsedAllCount]);

    return (
        <div>
            <div className="text-2xl flex items-center border-b border-tm-gray-200 py-2 pl-2">
                Comparison
            </div>

            {Object.keys({...tableSections.incomes, ...tableSections.expenses}).map(incomeListName => {
                return <ComparisonListItem
                    key={incomeListName}
                    name={incomeListName}
                    data={data}
                    columns={columns}
                    zeroValuesShown={!zeroValuesShown}
                    isSectionCollapsed={!!collapsedSection[incomeListName]}
                    onToggleSectionClick={() => handleToggleCollapseSectionClick(incomeListName)}
                    expandedAllCount={expandedAllCount}
                    collapsedAllCount={collapsedAllCount}
                    handleToggleAccountDetails={handleToggleAccountDetails}
                />
            })}
        </div>
    )
}

